module.exports = __webpack_public_path__ + "img/track.79522ca8.png";